import React, { useState } from "react";
import { NavLink } from "react-router-dom";
import Logo from "../../assets/img/logocare-3.png"; // Import logo image

const navLinks = [
	{ name: "Home", path: "/" },
	{ name: "About", path: "/about" },
	{ name: "Services", path: "/services" },
	{ name: "Impact", path: "/impact" },
	{ name: "Donate", path: "/donate" },
	{ name: "Our Approach", path: "/our-approach" },
	{ name: "Contact Us", path: "/contact" },
	// { name: "Get Involved", path: "/get-involved" }
];

const Navbar = () => {
	const [isSidebarOpen, setIsSidebarOpen] = useState(false);

	// Toggle Sidebar visibility
	const toggleSidebar = () => {
		setIsSidebarOpen(!isSidebarOpen);
	};

	return (
		<header className='bg-white border-[#E5E5E5]8 fixed top-0 z-[999999] w-full'>
			<div className='max-w-[1440px] xl:w-[90%] lg:w-[95%] w-[90%] mx-auto flex justify-between items-center py-1.5'>
				<div className=' flex items-center xl:space-x-16 space-x-10'>
					{/* Logo */}
					<NavLink to='/'>
						<img src={Logo} alt='Logo' className='h-16 w-full' />
					</NavLink>
					{/* Menu Items */}
					<ul className='hidden xl:flex items-center xl:space-x-6 space-x-4  text-[#1D1D1D] rounded-full font-normal'>
						{navLinks.map((link) => (
							<li key={link.path}>
								<NavLink
									to={link.path}
									className={({ isActive }) =>
										`transition duration-300 ${
											isActive
												? "text-[#22E27F] font-bold"
												: "hover:text-[#22E27F]"
										}`
									}>
									{link.name}
								</NavLink>
							</li>
						))}
					</ul>
				</div>
				<div className='flex items-center gap-x-4'>
					<div className='hidden lg:flex items-center xl:space-x-6 space-x-3 font-semibold text-base leading-6'>
						<NavLink
							to='/get-started'
							className='bg-[#1bb96a] text-black px-3 md:px-8 py-2 rounded-full font-medium hover:bg-[#45E99E] hover:text-white transition duration-300'>
							Get Started
						</NavLink>
						<NavLink
							to='/get-involved'
							className='bg-transparent text-[#1bb96a] border border-[#1bb96a] px-5 md:px-8 py-2 rounded-full font-medium hover:bg-[#1bb96a] hover:text-white transition duration-300'>
							Get Involved
						</NavLink>
					</div>
					<button
						onClick={toggleSidebar}
						className='text-[#45E99E] p-2 rounded-md block xl:hidden'>
						<svg
							xmlns='http://www.w3.org/2000/svg'
							fill='none'
							viewBox='0 0 24 24'
							stroke='currentColor'
							className='w-6 h-6'>
							<path
								strokeLinecap='round'
								strokeLinejoin='round'
								strokeWidth='2'
								d='M4 6h16M4 12h16M4 18h16'
							/>
						</svg>
					</button>
				</div>
			</div>
			{/* Mobile Sidebar */}
			{isSidebarOpen && (
				<div className='fixed inset-0 bg-black/50 z-50'>
					<div className='w-[80%] bg-white h-full p-4 relative'>
						<button
							onClick={toggleSidebar}
							className='text-[#1D1D1D] absolute top-4 right-4'>
							<svg
								xmlns='http://www.w3.org/2000/svg'
								fill='none'
								viewBox='0 0 24 24'
								stroke='currentColor'
								className='w-6 h-6'>
								<path
									strokeLinecap='round'
									strokeLinejoin='round'
									strokeWidth='2'
									d='M6 18L18 6M6 6l12 12'
								/>
							</svg>
						</button>
						<ul className='space-y-6 mt-12 w-[90%] mx-auto'>
							{navLinks.map((link) => (
								<li key={link.path}>
									<NavLink
										to={link.path}
										className='text-[#1D1D1D] text-xl font-normal block'
										onClick={() => setIsSidebarOpen(false)} // Close sidebar after clicking link
									>
										{link.name}
									</NavLink>
								</li>
							))}
							<li className='w-full lg:hidden block'>
								<NavLink
									to='/get-started'
									className='bg-[#1bb96a] text-black px-3 md:px-8 py-2 rounded-full font-medium hover:bg-[#45E99E] hover:text-white transition duration-300 w-full block text-center'>
									Get Started
								</NavLink>
							</li>
							<li className='w-full lg:hidden block'>
								<NavLink
									to='/get-involved'
									className='bg-transparent text-[#1bb96a] border border-[#1bb96a] px-5 md:px-8 py-2 rounded-full font-medium hover:bg-[#1bb96a] hover:text-white transition duration-300 w-full block text-center '>
									Get Involved
								</NavLink>
							</li>
						</ul>
					</div>
				</div>
			)}
		</header>
	);
};

export default Navbar;
